import { Alert, AlertDescription, AlertIcon, Box, Heading, Text } from '@chakra-ui/react';
import { Trans, useTranslation } from 'react-i18next';

interface IStepDescriptionProps {
  hasError: boolean;
}

export const StepDescription: React.FC<IStepDescriptionProps> = (props): JSX.Element => {
  const { t } = useTranslation();
  const { hasError } = props;

  return (
    <Box textAlign={{ base: 'center', md: 'left' }}>
      <Heading fontSize={{ base: 'h2.base', md: 'h2.md' }} fontWeight="normal" pb={2}>
        {t('WIZARD.SUMMARY.TITLE')}
      </Heading>
      <Text fontSize="large" mb={8}>
        <Trans i18nKey="WIZARD.SUMMARY.CONTENT" />
      </Text>
      {hasError && (
        <Alert mb={8} status="error" w="75%">
          <AlertIcon />
          <AlertDescription>
            <Trans i18nKey="WIZARD.SUMMARY.ERROR" />
          </AlertDescription>
        </Alert>
      )}
    </Box>
  );
};
